import { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { CircularProgress, Pagination } from '@mui/material';
import { useStyles } from '../../styles/styles';
import StyledCard from '../../components/cards/StyledCard';
import StyledCardContent from '../../components/cards/StyledCardContent';
import StyledCardHeader from '../../components/cards/StyledCardHeader';
import { useProvider } from '../../state/providerStore';
import { Api } from '../../api';
import { greenColor } from '../../components/main/react/App';

const formatDate = (dateStr: string) => {
  const date = new Date(dateStr);
  return date.toLocaleString('sl-SI', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  });
};

const PAGE_SIZE = 50;

const PartnerDetailsEvents = observer(({ partnerid }: { partnerid: string }) => {
  const classes = useStyles();
  const eventsProvider = useProvider(undefined, undefined, false);
  const [page, setPage] = useState(0);

  useEffect(() => {
    eventsProvider.setRequest(() =>
      Api.charge.listPartnerEvents(partnerid, page * PAGE_SIZE, PAGE_SIZE),
    );
    eventsProvider.reloadResource();
  }, [partnerid, page]);

  if (eventsProvider.loading) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          height: '60vh',
        }}
      >
        <CircularProgress style={{ color: greenColor }} />
      </div>
    );
  }

  const raw = eventsProvider.data;
  const events: any[] = Array.isArray(raw) ? raw : raw?.events || [];
  const totalCount: number = Array.isArray(raw) ? raw.length : raw?.totalCount || 0;
  const totalPages = Math.max(1, Math.ceil(totalCount / PAGE_SIZE));

  return (
    <div className={classes.cardRows}>
      <div style={{ width: '100%' }}>
        <StyledCard>
          <StyledCardHeader title={`Events${totalCount ? ` (${totalCount})` : ''}`} />
          <StyledCardContent>
            {events.length === 0 && (
              <div style={{ color: 'gray', padding: '1rem 0' }}>No events recorded yet.</div>
            )}
            {events.map((event: any) => (
              <div
                key={event.id}
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  padding: '0.75rem 0',
                  borderBottom: '1px solid #eee',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  <div style={{ fontWeight: 500 }}>{event.eventType}</div>
                  <div style={{ fontSize: '0.85rem', color: 'gray' }}>
                    {formatDate(event.createdAt)}
                  </div>
                </div>
                {event.description && (
                  <div style={{ fontSize: '0.9rem', color: '#555', marginTop: '0.25rem' }}>
                    {event.description}
                  </div>
                )}
                {event.metadata && Object.keys(event.metadata).length > 0 && (
                  <details style={{ marginTop: '0.5rem' }}>
                    <summary style={{ cursor: 'pointer', fontSize: '0.85rem', color: 'gray' }}>
                      Metadata
                    </summary>
                    <pre
                      style={{
                        background: '#f5f5f5',
                        padding: '0.5rem',
                        borderRadius: '4px',
                        fontSize: '0.8rem',
                        overflow: 'auto',
                        marginTop: '0.25rem',
                      }}
                    >
                      {JSON.stringify(event.metadata, null, 2)}
                    </pre>
                  </details>
                )}
              </div>
            ))}
            {totalPages > 1 && (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  paddingTop: '1rem',
                }}
              >
                <Pagination
                  count={totalPages}
                  page={page + 1}
                  onChange={(_, p) => setPage(p - 1)}
                  size="small"
                />
              </div>
            )}
          </StyledCardContent>
        </StyledCard>
      </div>
    </div>
  );
});

export default PartnerDetailsEvents;
